export default function Marquee({ items }) {
  const list = items.map((t, i) => (
    <span key={i} className="flex items-center shrink-0">
      <span className="font-serif italic text-xl sm:text-2xl text-sand/85 whitespace-nowrap px-6">{t}</span>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="text-moss shrink-0" aria-hidden="true">
        <path d="M12 2C7 7 4.5 11.5 4.5 15a7.5 7.5 0 0015 0c0-3.5-2.5-8-7.5-13z" stroke="currentColor" strokeWidth="1.6" />
      </svg>
    </span>
  ));
  return (
    <div className="overflow-hidden bg-forest-dark py-5 border-y border-sand/10" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        <div className="flex items-center shrink-0">{list}</div>
        <div className="flex items-center shrink-0" aria-hidden="true">{list}</div>
      </div>
    </div>
  );
}
